import SiteModal, { SiteFormValues } from '../../components/location-management/SiteModal';
import { StorageSite } from '../../types/interfaces';
import { createStorageSite, updateStorageSite } from '../../api/storageItemsApi';

type RsgSiteModalProps = {
  mode: 'add' | 'edit';
  close: () => void;
  site?: StorageSite;
  setSelectedId?: (id: number) => void;
};

const RsgSiteModal = ({ mode, close, site, setSelectedId }: RsgSiteModalProps): JSX.Element => {
  const siteValues = site ? { name: site.name, active: site.active } : undefined;

  const createSite = async ({ name, active }: SiteFormValues) => {
    const { data: id } = await createStorageSite({ name, active });
    return id;
  };

  const updateSite = async ({ name, active }: SiteFormValues) => {
    if (!site) {
      return;
    }
    await updateStorageSite(site.storageSiteId, { name, active });
  };

  return (
    <SiteModal
      mode={mode}
      close={close}
      site={siteValues}
      setSelectedId={setSelectedId}
      createSite={createSite}
      updateSite={updateSite}
    />
  );
};

export default RsgSiteModal;
